module.exports = __webpack_public_path__ + "static/08-fa7bc6655ce6c10105645ea2ad634157.png";